import { getResourceWatchUntil } from '../api/realtime';

const placeholderTitle = /^(?:creating (?:story|chapter)|getting things started)(?:\.{3}|…)?$/i;

/** A persisted pending bit is not a heartbeat. Match the same bounded activity
 * window used by Classic realtime, and retain unfinished stories for review. */
export function savedStoryActivity(story: Record<string, any>) {
  const incomplete = story.pending === true || Number(story.pendingChapterCount || 0) > 0 || story.failed === true;
  const dated = [story.realtimeWatchUntil, story.watchUntil, story.updatedAt, story.updateDate, story.lastUpdateDate, story.createDate, story.createdAt]
    .some(value => value != null && value !== '' && (Number(value) > 0 || Date.parse(String(value)) > 0));
  // Classic's generic watch helper starts a window for undated *new* records.
  // A restored library row is not a new request, so it must never use that path.
  const working = incomplete && !story.failed && dated && !!getResourceWatchUntil(story, { pending: true });
  return { incomplete, working };
}

export function savedStoryDisplayTitle(story: Record<string, any>, allowActivity = true) {
  const title = story.storyName || story.chapterTitle || story.title || 'Untitled story';
  return placeholderTitle.test(title.trim()) && (!allowActivity || !savedStoryActivity(story).working)
    ? 'Unfinished story' : title;
}
